import Collection from '@/components/Collection'
import CreateUser from '@/pages/user/CreateForm'
import UpdateUser from '@/pages/user/EditForm'
import DeleteUser from '@/pages/user/DeleteForm'
import QuestionsForm from '@/pages/user/QuestionsForm'
import access from "../access";
import i18n from '@/plugins/i18n';
import History from '@/pages/event/Detail';

export default {

  'user.collection': {
    path: '/admin/users',
    name: 'user.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listUsers",
      entity: "user",
      cols: [
        {
          label: "User ID",
          sort: "id",
          uuid: "user_id",
        },
        {
          label: "Registrar",
          sort: "registrar",
          component: "RouteLabelConverter",
          componentProps: (row) => {
            return {
              request: {registrar_id: row.registrar_id},
              placeholder: row.registrar_id,
              call: "viewRegistrar",
              handler: function(data) {
                return data.name + ", " + data.org;
              },
              route: {
                to: {
                  name: "registrar.view",
                  params: {
                    id: row.registrar_id,
                  },
                },
              }
            };
          },
        },
        { label: "Login name", field: "login_name" },
        { label: "Roles", html: (row) => row.roles.join(', ') },
        { label: "Access via GUI", html: (row) =>  i18n.T([row.gui_login ? 'yes' : 'no'])},
        { label: "Access via EPP", html: (row) =>  i18n.T([row.epp_login ? 'yes' : 'no'])},
      ],
      actions: (row) => {
        return [
          { name: "user.update", label: "edit", icon: "pencil2", params: {user_id: row.user_id} },
          { name: "user.delete", label: "delete", icon: "bin", params: {user_id: row.user_id} },
        ];
      }
    },
    meta: {
      access: access.admin,
      title: "User list",
      side_menu: { label: "Users",  icon: "users" },
      local_actions: [
        { name: "user.create", label: "Create user", color: "success", icon: "plus" }
      ]
    },
  },

  'user.create': {
    path: '/admin/users/create',
    name: 'user.create',
    component: CreateUser,
    meta: {
      access: access.admin,
      title: "Create new user"
    },
  },

  'user.history': {
    path: '/admin/users/history/:user_id',
    name: 'user.history',
    component: History,
    props: (route) => {
      return {
        domain: "rreg",
        type: "user",
        id: route.params.user_id,
      }
    },
    meta: {
      access: access.admin,
      title: "View history of changes",
      local_tasks: [
        { name: "user.history", label: "History"},
        { name: "user.update", label: "Edit"},
        { name: "user.questions", label: "Account Recovery"},
        { name: "user.delete", label: "Delete"}
      ]
    },
  },

  'user.update': {
    path: '/admin/users/update/:user_id',
    name: 'user.update',
    component: UpdateUser,
    props: (route) => {
      return {
        user_id: route.params.user_id,
      }
    },
    meta: {
      access: access.authenticated,
      title: "Update user details",
      local_tasks: [
        { name: "user.history", label: "History"},
        { name: "user.update", label: "Edit"},
        { name: "user.questions", label: "Account Recovery"},
        { name: "user.delete", label: "Delete"}
      ]
    },
  },

  'user.questions': {
    path: '/admin/users/questions/:user_id',
    name: 'user.questions',
    component: QuestionsForm,
    props: (route) => {
      return {
        user_id: route.params.user_id,
      }
    },
    meta: {
      access: access.chain(access.authenticated, function(user, params) {
        return user.id === params.user_id;
      }),
      title: "Update account recovery questions",
      local_tasks: [
        { name: "user.history", label: "History"},
        { name: "user.update", label: "Edit"},
        { name: "user.questions", label: "Account Recovery"},
        { name: "user.delete", label: "Delete"}
      ]
    },
  },

  'user.delete': {
    path: '/admin/users/delete/:user_id',
    name: 'user.delete',
    component: DeleteUser,
    props: (route) => {
      return {
        user_id: route.params.user_id,
      }
    },
    meta: {
      access: access.admin,
      title: "Delete user",
      local_tasks: [
        { name: "user.history", label: "History"},
        { name: "user.update", label: "Edit"},
        { name: "user.questions", label: "Account Recovery"},
        { name: "user.delete", label: "Delete"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/user.js